module.exports = __webpack_public_path__ + "static/media/linfoma-mediana.ced6edb5.jpg";